import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FilterTab from '../../components/common/FilterTab';
import SearchBox from '../../components/common/SearchBox';
import ToggleViewButton from '../../components/common/ToggleViewbutton';
import FourGrid from '../../components/icons/FourGrid';
import { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

// value must match the top-level Standard.name (upper-cased) so counts line up
const TAB_DEFS = [
  { label: 'CYYF', value: 'CYYF' },
  { label: 'CYABYF', value: 'CYABYF' },
  { label: 'MYYM', value: 'MYYM' },
  { label: 'N2XH', value: 'N2XH' },
  { label: 'RVK', value: 'RVK' },
  { label: 'MYYUP', value: 'MYYUP' },
  { label: 'MYF', value: 'MYF' },
  { label: 'FY', value: 'FY' },
  { label: 'Copper Rope Solid', value: 'COPPER_ROPE_SOLID' },
  { label: 'Copper Rope Flexible', value: 'COPPER_ROPE_FLEXIBLE' }
];

const StandardTopSection = ({
  activeView,
  activeCable,
  setActiveCable,
  counts = {},
  filterQuery = '',
  setFilterQuery
}) => {
  const navigate = useNavigate();

  const tabItems = useMemo(
    () =>
      TAB_DEFS.map(t => ({
        ...t,
        count: counts[t.value] ?? 0
      })),
    [counts]
  );

  const handleSearchInputChange = e => {
    if (typeof setFilterQuery === 'function') {
      setFilterQuery(e.target.value || '');
    }
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-4">
      <Col xs={12} sm="auto">
        <FilterTab
          tabItems={tabItems}
          activeKey={activeCable}
          onSelect={value => setActiveCable(value)}
        />
      </Col>
      <Col xs={12} sm="auto">
        <div className="d-flex align-items-center gap-1">
          <SearchBox
            value={filterQuery}
            onChange={handleSearchInputChange}
            placeholder="Filter: 3x2.5  ·  5x25+16"
            style={{ maxWidth: '30rem' }}
            className="me-3"
          />
          <ToggleViewButton
            tooltip="List view"
            active={activeView === 'list'}
            onClick={() => {
              navigate('/apps/project-management/project-list-view');
            }}
          >
            <FontAwesomeIcon icon={faList} className="fs-10" />
          </ToggleViewButton>

          <ToggleViewButton
            tooltip="Card view"
            active={activeView === 'card'}
            onClick={() => {
              navigate('/apps/project-management/project-card-view');
            }}
          >
            <FourGrid />
          </ToggleViewButton>
        </div>
      </Col>
    </Row>
  );
};

export default StandardTopSection;
